/**
 * Sidebar component constants
 *
 * Centralized magic numbers and constants for consistent styling
 * across sidebar components.
 */

/** Dropdown menu width for all sidebar dropdowns */
export const SIDEBAR_DROPDOWN_WIDTH = 'w-[248px]';

/** Logo height when sidebar is collapsed or expanded */
export const SIDEBAR_LOGO_HEIGHT = 10.378;

/** Dropdown side offset when sidebar is collapsed */
export const SIDEBAR_DROPDOWN_OFFSET_COLLAPSED = 16;

/** Dropdown side offset when sidebar is expanded */
export const SIDEBAR_DROPDOWN_OFFSET_EXPANDED = 12;

/** Helper to get dropdown side offset based on sidebar state */
export const getSidebarDropdownOffset = (isCollapsed: boolean): number =>
  isCollapsed
    ? SIDEBAR_DROPDOWN_OFFSET_COLLAPSED
    : SIDEBAR_DROPDOWN_OFFSET_EXPANDED;
